export const github = 'https://github.com/zlarsen'
export const linkedin = 'https://www.linkedin.com/in/zachlarsen/'
